// AI生视频
const sunoRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `AIMusic/suno/index${i + 1}`,
  name: `AIMusic/suno/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIMusic/suno/index${i + 1}.vue`)
}))


const dbRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `AIMusic/db/index${i + 1}`,
  name: `AIMusic/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIMusic/db/index${i + 1}.vue`)
}))


import AIMusicIndex from '@/views/smartLife/AIMusic/index'



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'AIMusic/index',
        name: 'AIMusicIndex',
        component: AIMusicIndex
      },
    // AI音乐，开始
    ...sunoRoutes,
    ...dbRoutes,
    // AI音乐，结束


  ],
};
